export default "/images/black-thin-arrow.svg?fac3e1657fc6f3a77213db5a0c1c00be";